document.addEventListener('DOMContentLoaded', () => {
  $('.sub-titles').expander({
    slicePoint: 75,
    expandText: '...',
    expandPrefix: '',
    userCollapseText: '[esconder]',
  });
});
